var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "statistics_mobile_places_filter",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "statistics_mobile_places_filter" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "statistics_mobile_places_filter_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("statisticsFilters.mobilePlaceFilter.title")) +
                " "
            ),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "statistics_mobile_places_filter_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("statistics_mobile_places_filter")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _c("BBDropdown", {
            attrs: { positionClass: "center" },
            scopedSlots: _vm._u([
              {
                key: "toggle",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedPlace
                            ? _vm.selectedPlace.name
                            : _vm.$t(
                                "statisticsFilters.mobilePlaceFilter.allLocationsLabel"
                              )
                        )
                      ),
                    ]),
                    _c("i", { staticClass: "la la-angle-down" }),
                  ]
                },
                proxy: true,
              },
              {
                key: "items",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "action-item",
                        class: !_vm.selectedPlace ? "selected" : "",
                        on: {
                          click: function ($event) {
                            return _vm.selectPlace()
                          },
                        },
                      },
                      [
                        _c("i", {
                          class: !_vm.selectedPlace ? "fas fa-check" : "",
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "statisticsFilters.mobilePlaceFilter.allLocationsLabel"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._l(_vm.allPlaces, function (place) {
                      return _c(
                        "div",
                        {
                          key: place.id,
                          staticClass: "action-item",
                          class:
                            _vm.selectedPlace &&
                            _vm.selectedPlace.id === place.id
                              ? "selected"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.selectPlace(place)
                            },
                          },
                        },
                        [
                          _c("i", {
                            class:
                              _vm.selectedPlace &&
                              _vm.selectedPlace.id === place.id
                                ? "fas fa-check"
                                : "",
                          }),
                          _c("span", [_vm._v(_vm._s(place.name))]),
                        ]
                      )
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }